const priorityCountryOrder = [
  'USA',
  'USA (2)',
  'United Kingdom',
  'Germany',
  'France',
  'Spain',
  'Israel',
  'Canada',
  'Netherlands',
  'South Africa',
  'Switzerland'
];

const priorityIndex = new Map(priorityCountryOrder.map((name, index) => [name, index]));

export const sortVirtualNumberCountries = (countries = []) => {
  return [...countries].sort((a, b) => {
    const aPriority = priorityIndex.has(a.countryName) ? priorityIndex.get(a.countryName) : Infinity;
    const bPriority = priorityIndex.has(b.countryName) ? priorityIndex.get(b.countryName) : Infinity;

    if (aPriority !== bPriority) {
      return aPriority - bPriority;
    }

    return a.countryName.localeCompare(b.countryName, undefined, { sensitivity: 'base' });
  });
};
